module.exports = __webpack_public_path__ + "img/addFood.1fb4adb2.png";